// Module
var code = `<section class="group-loans-create-form customer-loans-create-details">
    <div id="accordion" class="accordion">
        <div class="accordion-group"
             ng-repeat="member in \$ctrl.memberApplications"
             ng-init="newMemberData = \$ctrl.newMemberData[member.id]"
             ng-class="{
                'accordion-group--template-item': member.default,
                'accordion-group--invalid-form': newMemberData.createParametersForm.\$invalid ||
                                                 newMemberData.createLaiDetailsForm.\$invalid ||
                                                 newMemberData.overrideForm.\$invalid ||
                                                 newMemberData.headerForm.\$invalid
             }">
          <div class="accordion-header accordion-toggle" data-toggle="collapse"
               data-parent="#accordion" data-target="#member-{{member.id}}"
               tab-index="-1"
               ng-form name="newMemberData.headerForm"
          >
            <a class="accordion-header-label" role="button">{{ member.effectiveName }}</a>
            <table ng-if="!member.default" class="accordion-header-form">
              <tr class="accordion-header-form-field">
                <td class="label">
                  Principal
                </td>
                <td class="values">
                  <div class="row-info-section">
                    <cash prepend="'min.'"
                          ng-model="newMemberData.newProduct.minAmount"
                          ng-disabled="true"></cash>
                  </div>
                  <cash class="value"
                        ng-model="newMemberData.loan.principalAmount"
                        required
                        min="newMemberData.newProduct.minAmount"
                        max="newMemberData.newProduct.maxAmount"
                        hide-currency="true"></cash>
                  <div class="row-info-section">
                    <cash prepend="'max.'"
                          value="newMemberData.newProduct.maxAmount"
                          ng-disabled="true"></cash>
                  </div>
                </td>
              </tr>
              <tr class="accordion-header-form-field">
                <td class="label">
                  Creation Type
                </td>
                <td class="values">
                  <select
                          ng-model="newMemberData.loan.creationType"
                          ng-options="entry.value as entry.label for entry in \$ctrl.creationTypes"
                          ng-required="true"></select>
                </td>
              </tr>
            </table>
            <div class="accordion-header-buttons">
              <button
                  ng-if="member.default"
                  ng-click="\$ctrl.copyDefaultConfigurationToAll()"
                  class="btn">
                Copy configuration to all
              </button>
              <button
                  ng-if="!member.default"
                  ng-click="\$ctrl.copyDefaultConfigurationToHere(newMemberData)"
                  class="btn">
                Copy default configuration here
              </button>
              <button
                  ng-if="!member.default"
                  ng-click="\$ctrl.removeMember(member)"
                  class="btn btn-danger">
                Remove member from configuration
              </button>
            </div>
          </div>
          <div id="member-{{member.id}}" class="accordion-body collapse">
            <div class="accordion-inner">
              <div class="panel-body">
                <customer-loan-create-parameters
                    ng-if="\$ctrl.product"
                    form-param="newMemberData.createParametersForm"
                    customer-id="newMemberData.loan.customerId"
                    loan="newMemberData.loan"
                    loan-product="newMemberData.newProduct"
                    group-loan="true"
                    hide-simulation="member.default"
                >
                </customer-loan-create-parameters>

                <customer-loan-create-lai-details
                    customer-id="newMemberData.loan.customerId"
                    form-lai="newMemberData.createLaiDetailsForm"
                    loan-information="newMemberData.loan.loanInformation"
                    loan-collaterals="newMemberData.loan.collaterals"
                    loan-product="newMemberData.newProduct"
                    group-loan="true"
                    category-ids="newMemberData.loan.categoryIds"
                    custom-field-values="newMemberData.loan.customFieldValues"
                    branch-id="newMemberData.loan.branchId"
                >
                </customer-loan-create-lai-details>
                <ng-form name="newMemberData.loanDocumentsForm">
                  <loan-documents loan="newMemberData.loan"></loan-documents>
                </ng-form>
                <customer-loan-charges-override
                    ng-if="!member.default"
                    form-name="newMemberData.overrideForm"
                    loan="newMemberData.loan"
                    loan-product="newMemberData.newProduct"
                    override-required="true"
                >
                </customer-loan-charges-override>
              </div>
            </div>
          </div>
        </div>
    </div>
    <div class="summary-actions">
      <button class="btn btn-warning"
              ng-click="\$ctrl.formCancelAction()">
        Cancel
      </button>
        <button class="btn btn-success"
                ng-disabled="\$ctrl.formInvalid()"
                ng-click="\$ctrl.formReady()">
            Ready
        </button>
    </div>
</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/group-loans/group-loans-create/group-loans-create-form.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;